export default "__VITE_ASSET__DSU$2Egj__"